

import React from "react";

const baseBlock = (width, height, extraStyles = {}) => ({
  width,
  height,
  backgroundColor: "rgba(0,0,0,0.08)",
  borderRadius: 6,
  marginBottom: 10,
  ...extraStyles,
});

const Line = ({ width = "100%", height = 14, style }) => (
  <div style={baseBlock(width, height, style)} />
);

const Circle = ({ size = 60, style }) => (
  <div style={baseBlock(size, size, { borderRadius: "50%", ...style })} />
);

function LoadingCardDetail() {
  return (
    <>
      <div className="CategoryTitle pt-tophead">
        <ul className="Breadcrumb">
          {Array.from({ length: 4 }).map((_, idx) => (
            <li key={idx}>
              <Line width={`${60 - idx * 10}%`} height={12} style={{ marginBottom: 0 }} />
            </li>
          ))}
        </ul>
        <Line width="50%" height={24} style={{ marginBottom: 0 }} />
      </div>

      <section className="DetallesProducto">
        <div>
          <div className="ProductoImagenes">
            <div
              className="card-loader card-loader--tabs"
              style={{
                ...baseBlock("100%", 520, { marginBottom: 20, padding: 0 }),
                boxShadow: "none",
              }}
            >
              <div className="RotateFlag" style={{ padding: 16 }}>
                <Line width="35%" height={22} />
                <Line width="30%" height={22} />
              </div>
            </div>

            <div className="Thumbnail" data-i={0}>
              <div className="icon-CaretLeft" />
              <ul style={{ display: "flex", gap: 12, alignItems: "center" }}>
                {Array.from({ length: 5 }).map((_, idx) => (
                  <li key={idx}>
                    <Circle size={64} />
                  </li>
                ))}
              </ul>
              <div className="icon-CaretRight" />
            </div>
          </div>

          <div className="ProductoDescripcion">
            <div>
              <div className="ItemDesc">
                <Line width="25%" height={14} />
                <Line width="75%" height={26} />
                <Line width="40%" height={14} />
                <Line width="60%" height={32} />
                <Line width="50%" height={18} />
                <Line width="90%" height={14} />
                <Line width="85%" height={14} />
              </div>

              <div className="SeleccionaColor">
                <Line width="30%" height={16} />
                <div className="color-options" style={{ display: "flex", gap: 10 }}>
                  {Array.from({ length: 4 }).map((_, idx) => (
                    <Circle key={idx} size={42} />
                  ))}
                </div>
              </div>

              <div className="SeleccionaTalla" data-i={0}>
                <Line width="30%" height={16} />
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div className="icon-CaretLeft" />
                  <ul style={{ display: "flex", gap: 8 }}>
                    {Array.from({ length: 6 }).map((_, idx) => (
                      <li key={idx}>
                        <div style={baseBlock(42, 42, { borderRadius: 8 })} />
                      </li>
                    ))}
                  </ul>
                  <div className="icon-CaretRight" />
                </div>
              </div>

              <div className="SeleccionaCantidad">
                <Line width="35%" height={16} />
                <div className="counter" style={{ display: "flex", gap: 8, marginTop: 10 }}>
                  <div style={baseBlock(40, 36, { borderRadius: 6, marginBottom: 0 })} />
                  <div style={baseBlock(80, 36, { borderRadius: 6, marginBottom: 0 })} />
                  <div style={baseBlock(40, 36, { borderRadius: 6, marginBottom: 0 })} />
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 20 }}>
                <div className="ButtonDarkMedium" style={baseBlock("100%", 48, { marginBottom: 0 })} />
                <div className="ButtonLightMedium" style={baseBlock("100%", 48, { marginBottom: 0 })} />
              </div>

              <div className="description" style={{ marginTop: 24 }}>
                <Line width="30%" height={16} />
                <Line width="100%" height={12} />
                <Line width="90%" height={12} />
                <Line width="80%" height={12} />
                <Line width="70%" height={12} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LoadingCardDetail;

